module.exports = __webpack_public_path__ + "static/media/reuma-nav.f00553a9.png";